import React from 'react';
import { useNotification } from '../context/NotificationContext';
import Toast from './Toast';

const ToastContainer = () => {
  const { toasts, dismiss } = useNotification();

  if (toasts.length === 0) return null;

  return (
    <div className="toast-container">
      {toasts.map((toast) => (
        <Toast key={toast.id} toast={toast} onClose={dismiss} />
      ))}
    </div>
  );
};

export default ToastContainer;
